module.exports = __webpack_public_path__ + "media/images/site/semi_aprovados2-c2bbee38753059bd70121b1806877cdc.jpg";